import { lazy } from 'react'
import { observer } from 'mobx-react-lite'
import { useFeatures } from '@/contexts/root-store-context'

const Inner = lazy(() => import('./Inner'))

/**
 * Hosts the job dialogs that may be invoked from anywhere else in the app.
 */
export const JobDialogsHost = observer(function JobDialogsHost() {
  const { isJobsRequested } = useFeatures(({ jobs }) => ({
    isJobsRequested: jobs.internal.isRequested,
  }))

  // Rendering the dialogs loads the feature, so wait until something else has.
  if (!isJobsRequested()) {
    return null
  }

  return <Inner />
})
